import React, { type FC, useContext } from 'react';
import classNames from 'classnames';

import { Button, ButtonIntent, ButtonType } from 'app/design-system/components/Button';
import { Icon, IconSize } from 'app/design-system/components/Icon';
import { StepperContext } from 'app/design-system/components/Stepper/context';
import { useTranslation } from 'app/lang';

import { FORWARD_BUTTON_CONTENT } from '../../constants';
import { RegContext } from '../../context';

import styles from './SignModal.module.scss';

export const SignFooter: FC = () => {
  const { t } = useTranslation();

  const { regData } = useContext(RegContext);
  const { activeStep } = useContext(StepperContext);

  const { disabled, checked } = regData;

  const buttonTextClassNames = classNames(styles.footerEnterButton, {
    [styles.iconButton]: activeStep === 3,
  });

  const forwardButtonText = checked
    ? (
      <Icon icon="check"
            size={IconSize.MEDIUM}
            className={styles.iconSuccess} />
    )
    : (
      t(FORWARD_BUTTON_CONTENT[`STEP${activeStep}`])
    );

  return (
    <div className={styles.container}>
      <Button type={ButtonType.SUBMIT}
              intent={!checked ? ButtonIntent.CALL_TO_ACTION : ButtonIntent.SUCCESS}
              form={`registrationFormStep_${activeStep}`}
              loading={disabled && !checked}
              className={buttonTextClassNames}
              block
              data-test="registration-submit">
        {forwardButtonText}
      </Button>
    </div>
  );
};
